// Temas: área profissional ("mio-theme") e Portal do Paciente ("mio-portal-theme", independente, só neste dispositivo).
// Assinatura pública e guia fotográfico ficam sempre escuros.
const KEY = "mio-theme";
const PORTAL_KEY = "mio-portal-theme";
const ALWAYS_DARK = /^\/sign\/|^\/guia-fotografico/;
const isPortal = () => /^\/portal\//.test(window.location.pathname);
const mq = () => window.matchMedia?.("(prefers-color-scheme: light)");

const read = (key) => {
  try { return ["light", "dark", "auto"].includes(localStorage.getItem(key)) ? localStorage.getItem(key) : "dark"; }
  catch { return "dark"; }
};

export const getThemePref = () => read(KEY);
export const getPortalThemePref = () => read(PORTAL_KEY);

export function applyTheme(pref) {
  const p = pref || (isPortal() ? getPortalThemePref() : getThemePref());
  const light = !ALWAYS_DARK.test(window.location.pathname) && (p === "light" || (p === "auto" && !!mq()?.matches));
  document.documentElement.classList.toggle("light", light);
}

export function setThemePref(pref) {
  try { localStorage.setItem(KEY, pref); } catch { /* sem armazenamento */ }
  applyTheme(pref);
}

export function setPortalThemePref(pref) {
  try { localStorage.setItem(PORTAL_KEY, pref); } catch { /* sem armazenamento */ }
  applyTheme(pref);
}

// Reage a mudanças do sistema quando a preferência é "auto".
mq()?.addEventListener?.("change", () => applyTheme());
